import React from 'react'
import styled from 'styled-components'
import { desktopVW, mobileVW } from '../../styles'
import theme from '../../styles/theme'
import { SiteLink } from './SiteLink'
import Image from 'gatsby-image'

const { colors, easeOut, breakPoints, fontFamily, headerHeight } = theme

const AmbassadorItem = ({ data }) => {
  const { name, subTitle, seoImage: image, slug } = data ?? {}

  return (
    <Ambassador>
      <ImageWrapper>
        {image && <Img fluid={image.fluid} alt={image.title} />}
      </ImageWrapper>
      <Inner>
        <div>
          <Title>{name}</Title>
          <p>{subTitle}</p>
        </div>
      </Inner>
      <Link to={slug} />
    </Ambassador>
  )
}

const Img = styled(Image)`
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: 0.3s ease transform;
`

const Ambassador = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;

  @media screen and (min-width: ${breakPoints.desktop}) {
    &:hover ${Img} {
      transform: scale(1.05);
    }
  }
`

const ImageWrapper = styled.div`
  position: relative;
  background: ${colors.lightGrey};
  display: flex;
  overflow: hidden;

  &::before {
    content: '';
    width: 100%;
    padding-top: 100%;
  }
`

const Inner = styled.div`
  display: flex;
  align-items: center;
  font-size: ${mobileVW(14)};
  color: ${colors.grey};
  line-height: 1.5;
  margin-top: ${mobileVW(16)};

  &::after {
    content: '+';
    display: block;
    margin-left: auto;
    font-size: ${mobileVW(20)};
  }

  @media screen and (min-width: ${breakPoints.desktop}) {
    font-size: ${desktopVW(14, 1440)};
    margin-top: ${desktopVW(16, 1440)};

    &::after {
      font-size: ${desktopVW(20, 1440)};
    }
  }
`

const Link = styled(SiteLink)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
`

const Title = styled.h6`
  font-size: ${mobileVW(20)};
  color: ${colors.black};

  @media screen and (min-width: ${breakPoints.desktop}) {
    font-size: ${desktopVW(20, 1440)};
  }
`

export default AmbassadorItem
